// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_aa-4";
export var collapsed = "_aa-1";
export var headerBar = "_aa-0";
export var leftHeaderContent = "_aa-3";
export var subjectContainer = "_aa-2";